import { Pipe, PipeTransform } from '@angular/core';
import { FeedbackDto } from '@careapp-group/ng-sdk';

@Pipe({
    name: 'feedbackCount',
    pure: true,
    standalone: false
})
export class FeedbackCountPipe implements PipeTransform {
  transform(value: FeedbackDto[] = [], rating: number) {
    return value.filter((item) => +item.rating === +rating).length;
  }
}
